import styled from "styled-components";
import FadeIn from "react-fade-in";

export const FadeInBottom = styled(FadeIn)<{ mb?: string }>`
  > *:not(:last-child) {
    margin-bottom: ${({ mb }) => mb || "1rem"};
  }
`;
